import { render, staticRenderFns } from "./studentTransfer.vue?vue&type=template&id=2e809378&"
import script from "./studentTransfer.vue?vue&type=script&lang=js&"
export * from "./studentTransfer.vue?vue&type=script&lang=js&"
import style0 from "./studentTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports